/**
 * F112 (Pavel 2026-08-10): "Nikdo to nemuze vratit do puvodnich koleji, partak
 * ani zakaznik." A failed bot transfer was a dead end because the failure had
 * no honest name: BotFather's "Bot ownership can't be transferred to channel,
 * another bot or yourself." (the client had pasted the BOT's username into the
 * ownership form) fell through to `unknown`, which the server reads as OUR
 * problem, so the client kept the "pracujeme" card and never saw the form
 * again.
 *
 * This module is the ONE catalog of transfer failure names. The worker decides
 * the audience from it, the client step decides whether to offer the form from
 * it, the partner's status card labels the row from it, and
 * `buddypro-instance/transfer_bot_ownership.py` mirrors it in Python (the
 * runner is the only writer of these values). A reason that lives in only one
 * of those places is how F112 happened.
 */

/**
 * Reasons the CLIENT can act on: the input they typed was wrong, or the
 * account they named has not met Telegram's precondition. The step names the
 * reason and offers the ownership form again (F44).
 */
// 🔴 MERGE F112+F113 (dispecer 2026-08-10): katalog pricin zije JEN v
// bot-transfer-reasons.ts (F113 jmena, overena ziva zneni BotFathera). Tenhle
// modul ho pouze re-exportuje a pridava, co je navic F112: parťákovo vraceni
// k oprave a rozpoznani, ze klient vlozil jmeno bota.
export {
  BOT_TRANSFER_CLIENT_REASONS,
  BOT_TRANSFER_INTERNAL_REASONS,
  BOT_TRANSFER_REASONS,
  isBotTransferClientFault,
  isBotTransferReason
} from "./bot-transfer-reasons";
import {
  BOT_TRANSFER_CLIENT_REASONS,
  isBotTransferReason as isKnownReason
} from "./bot-transfer-reasons";
export type {
  BotTransferClientReason,
  BotTransferInternalReason,
  BotTransferReason
} from "./bot-transfer-reasons";


/**
 * What may appear as `bot_transfer_state.client_fix.reason`: every client-fault
 * failure, plus the partner's own "vrat to klientovi k oprave" (F112), which is
 * not a runner outcome but lands the client in the same place - the named
 * sentence and the form.
 */
export const BOT_TRANSFER_STAFF_RETURN_REASON = "staff_returned";
export const BOT_TRANSFER_FIX_REASONS = [
  ...BOT_TRANSFER_CLIENT_REASONS,
  BOT_TRANSFER_STAFF_RETURN_REASON
] as const;
export type BotTransferFixReason = (typeof BOT_TRANSFER_FIX_REASONS)[number];

export function isBotTransferFixReason(value: unknown): value is BotTransferFixReason {
  return typeof value === "string" && (BOT_TRANSFER_FIX_REASONS as readonly string[]).includes(value);
}

/** The one locale key shape for a reason, read by the mail, the client step
 *  card and the partner's status card. */
export function botTransferReasonKey(reason: string): string {
  return `botTransfer.reason.${isKnownReason(reason) ? reason : "unknown"}`;
}

/**
 * Telegram refuses a transfer to a bot, a channel or the account that owns the
 * bot right now. The server knows BOTH usernames, so the commonest form of it
 * (the client pasting the bot's own name, which is exactly what happened on
 * 2026-08-10) is answerable WITHOUT spending a BotFather round trip.
 */
export function recipientIsBotItself(botUsername: string, recipientUsername: string): boolean {
  const clean = (value: string) => value.trim().replace(/^@/, "").toLowerCase();
  const bot = clean(botUsername);
  return bot.length > 0 && bot === clean(recipientUsername);
}

/**
 * The bot changed hands INSIDE Telegram only in this one state. Everything
 * else (queued, running, failed, never started) means our database is still
 * the whole truth - and F104's "vratit nejde" sentence must not be printed
 * there, because it says the opposite of what happened.
 */
export function botOwnershipTransferred(state: unknown): boolean {
  return state === "transferred";
}
